import { Grid, TextField } from '@mui/material'
import { DateRange } from '@mui/x-date-pickers-pro'
import DateRangePicker, { DateRangeValidationError } from '../../../shared/UI/DateRangePickerV2'
import { isTabletDown } from '../../../theme/deviceChecks'
import DatePicker from '../../../shared/UI/DatePickerV2'

interface AbsenceTimeFramePickerProps {
  absenceRange: DateRange<Date>
  updateAbsenceRange: React.Dispatch<React.SetStateAction<DateRange<Date>>>
  onAbsenceRangeError: (error: DateRangeValidationError) => void
  shiftString: string
  updateShiftString: React.Dispatch<React.SetStateAction<string>>
  onShiftStringBlur: () => void
  expectedReturn: Date | null
  updateExpectedReturn: React.Dispatch<React.SetStateAction<Date | null>>
  onExpectedReturnError: (error: string | null) => void
  disableShiftStringEditing: boolean
  disableDatesSelection: boolean
  dateRangeError?: boolean
  shiftStringError?: boolean
}

function AbsenceTimeFramePicker({
  absenceRange,
  updateAbsenceRange,
  onAbsenceRangeError,
  shiftString,
  updateShiftString,
  onShiftStringBlur,
  expectedReturn,
  updateExpectedReturn,
  onExpectedReturnError,
  disableShiftStringEditing,
  disableDatesSelection,
  shiftStringError = false,
}: AbsenceTimeFramePickerProps) {
  return (
    <>
      <Grid item xs={12}>
        <DateRangePicker
          disabled={disableDatesSelection}
          value={absenceRange}
          required
          arrange={isTabletDown() ? 'Stack' : 'Horizontal'}
          onChange={updateAbsenceRange}
          onError={onAbsenceRangeError}
          dataTestId="MyActions-Absence-"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextField
          fullWidth
          label="Shift"
          name="shiftDescription"
          value={shiftString}
          onChange={event => {
            updateShiftString(event.target.value)
          }}
          disabled={disableShiftStringEditing}
          onBlur={onShiftStringBlur}
          data-testid="MyActions-Absence-shift"
          error={shiftStringError}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DatePicker
          label="Expected Return"
          value={expectedReturn}
          required
          onChange={updateExpectedReturn}
          onError={onExpectedReturnError}
          dataTestId="MyActions-Absence-ExpectedReturn"
        />
      </Grid>
    </>
  )
}

export default AbsenceTimeFramePicker
